import LayoutRow from './Row';
import LayoutColumn from './Column';
import LayoutContainer from './Container';

export const Row = LayoutRow;
export const Column = LayoutColumn;
export const Container = LayoutContainer;

const Layout = { Row, Column, Container };
export default Layout;
